import { IconeNome } from '@/shared/components/ui/icon';

export interface SubitemMenu {
  rotulo: string;
  rota: string;
  icone: IconeNome;
  logins?: string[];
}

export interface ItemMenu {
  rotulo: string;
  icone: IconeNome;
  rota?: string;
  logins?: string[];
  submenu?: SubitemMenu[];
}

/** Menu lateral/superior. Grupo com `logins` só aparece para esses e-mails. */
export const MENU: readonly ItemMenu[] = [
  {
    rotulo: 'Dashboard',
    icone: 'dashboard',
    rota: '/dashboard',
  },
  {
    rotulo: 'Cadastros',
    icone: 'cadastros',
    submenu: [
      { rotulo: 'Cabanhas', rota: '/cadastros/cabanhas', icone: 'cabanha' },
      { rotulo: 'Escritórios', rota: '/cadastros/leiloeiras', icone: 'escritorio' },
      { rotulo: 'Sindicatos', rota: '/cadastros/sindicatos', icone: 'usuarios' },
      { rotulo: 'Remates', rota: '/cadastros/remates', icone: 'remate' },
      { rotulo: 'Transmissoras', rota: '/cadastros/transmissoras', icone: 'transmissora' },
    ],
  },
  {
    rotulo: 'Financeiro',
    icone: 'financeiro',
    logins: [
      'ismael@rematefy.com',
      'roberta.devogeski@rematefy.com',
      'fabiane.hubner@rematefy.com',
      'thiago@nstecnologia.com.br',
      'fagner@rematefy.com',
    ],
    submenu: [
      { rotulo: 'Dashboard', rota: '/financeiro/dashboard', icone: 'dashboard' },
      { rotulo: 'Remates', rota: '/financeiro/remates', icone: 'remate' },
      { rotulo: 'Faturamento', rota: '/financeiro/faturamento', icone: 'financeiro' },
    ],
  },
  {
    rotulo: 'Marketing',
    icone: 'marketing',
    submenu: [
      { rotulo: 'Central de Parceiros', rota: '/cs/central-parceiros', icone: 'parceiros' },
    ],
  },
  {
    rotulo: 'Serviços',
    icone: 'servicos',
    submenu: [
      { rotulo: 'Cadastros', rota: '/servicos/cadastros', icone: 'lista' },
      { rotulo: 'Calculadora', rota: '/servicos/calculadora', icone: 'calculadora' },
      { rotulo: 'Tarifas por Leiloeira', rota: '/servicos/tarifas', icone: 'tarifas' },
    ],
  },
  {
    rotulo: 'Suporte',
    icone: 'suporte',
    submenu: [
      { rotulo: 'Acomp. Remates', rota: '/suporte/acompanhamento', icone: 'tv' },
      { rotulo: 'Notificações Web', rota: '/suporte/notificacoes-web', icone: 'notificacoes' },
      { rotulo: 'Monitor Rfy', rota: '/suporte/monitor-rfy', icone: 'monitor' },
      { rotulo: 'Convites genéticas', rota: '/suporte/radar-genetica', icone: 'dna' },
      { rotulo: 'Funil de Campanhas', rota: '/suporte/radar-genetica/campanhas', icone: 'filtro' },
    ],
  },
];
